// extracted by mini-css-extract-plugin
module.exports = {"headerCell":"CartCard-HeaderCell-module--header-cell--pZVZr utils-module--table-header--12VcE utils-module--uppercase--2OdP1"};